export const SET_REPORTS_LOADED = "SET_REPORTS_LOADED";

export const setReportsLoaded = (reportsLoaded: boolean) => {
  return {
    reportsLoaded,
    type: SET_REPORTS_LOADED
  };
};
